module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "displaybotwrap"
  }, [_c('a', {
    staticClass: "displaybot",
    on: {
      "click": _vm.displaybot
    }
  }, [_c('svg', {
    attrs: {
      "aria-labelledby": "simpleicons-allo-icon",
      "role": "img",
      "viewBox": "0 0 24 24",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('title', {
    attrs: {
      "id": "simpleicons-allo-icon"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M11.665.005c-.702.018-1.417.098-2.14.243C4.788 1.193 1.08 4.974.21 9.728c-1.36 7.406 4.096 14.256 11.16 14.256L22.227 24c.98 0 1.774-.793 1.774-1.774V12C24 5.26 18.445-.18 11.665.005zM12 6.135c3.238 0 5.862 2.626 5.862 5.865v5.61c0 .245-.293.367-.467.194l-1.46-1.46c-1.04.944-2.42 1.52-3.936 1.52-3.24 0-5.865-2.626-5.865-5.864 0-3.24 2.627-5.865 5.865-5.865z"
    }
  })])])]), _vm._v(" "), _c('lex-web-ui', {
    ref: "lexweb",
    class: _vm.showUI === true ? ' ' : 'noUI',
    attrs: {
      "localConfig": "localConfig"
    },
    on: {
      "updateLexState": _vm.onUpdateLexState
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f2fc6932"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Chat.vue
// module id = 1015
// module chunks = 1